/* eslint-disable @typescript-eslint/no-explicit-any */
import { AlertCircle, UserX } from "lucide-react";
import {
    Alert,
    AlertDescription,
    AlertTitle,
} from "@/components/ui/alert";

const DriverUnavailabilityAlerts = () => {
    const alerts: any = [];

    return (
        <div className="space-y-4">
            <div className="flex items-center space-x-2">
                <UserX className="text-gray-500 dark:text-gray-400" />
                <h2 className="text-lg font-semibold">
                    Driver Unavailability Alerts ({alerts.length})
                </h2>
            </div>
            <div className="space-y-2">
                {alerts.length === 0 ? (
                    <Alert
                        variant="default"
                        className="bg-gray-50 border-gray-200 text-gray-800 
                                   dark:bg-gray-900 dark:border-gray-700 dark:text-gray-200"
                    >
                        <AlertCircle className="h-5 w-5 text-gray-500 dark:text-gray-400" />
                        <AlertTitle>No Alerts</AlertTitle>
                        <AlertDescription>
                            Currently there are no driver unavailability alerts.
                        </AlertDescription>
                    </Alert>
                ) : (
                    <div className="space-y-2">
                        {alerts.map((alert: any, index: number) => (
                            <Alert
                                key={index}
                                variant="default"
                                className="bg-gray-50 border-gray-200 text-gray-800 
                                           dark:bg-gray-900 dark:border-gray-700 dark:text-gray-200"
                            >
                                <AlertCircle className="h-5 w-5 text-gray-500 dark:text-gray-400" />
                                <AlertTitle>{alert.title}</AlertTitle>
                                <AlertDescription>{alert.description}</AlertDescription>
                            </Alert>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DriverUnavailabilityAlerts;
